import React from "react";
import PropTypes from "prop-types";
import StepItem from "./StepItem";
import styles from "./StepBuilder.module.css";

/**
 * Lista editável de mensagens (steps) da cadência. Controlado pelo pai
 * (`SequenceFormModal`): recebe `steps` e devolve a nova lista via `onChange`.
 *
 * Não lida com stepOrder — o pai recalcula 1..N na hora de enviar ao backend.
 * Cada step do estado local tem shape { offsetDays, messageTemplate }.
 */
export default function StepBuilder({ steps, errors = {}, onChange }) {
  const updateStep = (index, patch) => {
    onChange(steps.map((s, i) => (i === index ? { ...s, ...patch } : s)));
  };

  const moveStep = (index, direction) => {
    const target = index + direction;
    if (target < 0 || target >= steps.length) return;
    const next = [...steps];
    [next[index], next[target]] = [next[target], next[index]];
    onChange(next);
  };

  const removeStep = (index) => {
    if (steps.length <= 1) return;
    onChange(steps.filter((_, i) => i !== index));
  };

  const addStep = () => {
    onChange([...steps, { offsetDays: 7, messageTemplate: "" }]);
  };

  return (
    <div className={styles.builder}>
      <ul className={styles.list}>
        {steps.map((step, index) => (
          <StepItem
            // Index é estável o suficiente aqui: a lista é pequena e sempre
            // re-renderiza inteira ao reordenar/remover (estado controlado).
            key={index}
            index={index}
            total={steps.length}
            offsetDays={step.offsetDays}
            messageTemplate={step.messageTemplate}
            error={errors[index] ?? null}
            onChangeOffset={(value) => updateStep(index, { offsetDays: value })}
            onChangeMessage={(value) =>
              updateStep(index, { messageTemplate: value })
            }
            onMoveUp={() => moveStep(index, -1)}
            onMoveDown={() => moveStep(index, 1)}
            onRemove={() => removeStep(index)}
          />
        ))}
      </ul>

      <button type="button" className={styles.addBtn} onClick={addStep}>
        <span aria-hidden="true">+</span> Adicionar mensagem
      </button>
    </div>
  );
}

StepBuilder.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      offsetDays: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      messageTemplate: PropTypes.string,
    }),
  ).isRequired,
  /** Mapa index → mensagem de erro do step. */
  errors: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onChange: PropTypes.func.isRequired,
};
